import { FC, useEffect, useRef } from 'react'
import { loadDatatransScript } from './datatransLoader'

// Drop-in replacement for react-datatrans-light-box's <Lightbox>: same props,
// but the script load is awaited (and retryable) instead of assumed.
type LightboxProps = {
  transactionId: string
  production?: boolean
  onLoaded?: () => void
  onOpened?: () => void
  onCancelled?: () => void
  onError?: (data: any) => void
}

export const DatatransLightbox: FC<LightboxProps> = ({
  transactionId,
  production = false,
  onLoaded,
  onOpened,
  onCancelled,
  onError,
}) => {
  const cancelled = useRef(false)

  useEffect(() => {
    cancelled.current = false

    loadDatatransScript(production)
      .then(() => {
        if (cancelled.current || !window.Datatrans) return
        window.Datatrans.startPayment({
          transactionId,
          loaded: onLoaded,
          opened: onOpened,
          closed: onCancelled,
          error: onError,
        })
      })
      .catch((err) => {
        if (!cancelled.current) {
          onError?.(err)
        }
      })

    return () => {
      cancelled.current = true
      if (window.Datatrans) {
        try {
          window.Datatrans.close()
        } catch {
          // lightbox may not be open — nothing to close
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return null
}
